import * as types from '../constants/ActionTypes';
import * as endPoints from '../constants/EndPoints';
import { fetchMiddleware, setIndexes, getIconFeatures } from './MiddlewareActions';
import { COUPLE_SAMPLES_COUNT_FOR_PAGE } from '../constants/Misc';

function findAlertInData(outputs, alertId) {
    let isInData = false;
    const rows = outputs.rows;

    if (rows) {
        for (let i = 0; i < rows.length; i++) {
            if (rows[i].LeakID == alertId) {
                isInData = true;
                break;
            }
        }
    }

    return (isInData);
}


//--------------------------------
// Couples Alerts (Pipes Assessment)
//--------------------------------
export function fetchCoupleAlertsIfNeeded(project, coupleId) {
    return (dispatch, getState) => {
        if (shouldFetchCoupleAlerts(getState(), project, coupleId)) {
            return dispatch(fetchCoupleAlerts(project, coupleId));
        }
    }
}

function shouldFetchCoupleAlerts(state, project, coupleId) {
    const assessments = state.leaksList.leaksByProject[project].assessments[coupleId];
    const haveToFetch = (assessments == null);
    return haveToFetch;
}

function fetchCoupleAlerts(project, coupleId) {
    const path = endPoints.PROJECTS_ENDPOINT + "/" + project + "/couple/" + coupleId + "/" + endPoints.LEAKS_ENDPOINT;

    return (dispatch, getState) => {
        dispatch(requestCoupleAssessments(project, coupleId));
        return fetchMiddleware(path, {}, getState)
            .then(json => {
                const options = getState().leaksList.optionList.options;
                return [setEnumsValues(options, json.data), getIconFeatures('assessments', json.data), setIndexes(json.data, 'id')];
            })
            .then(args => {
                dispatch(receiveCoupleAssessments(project, coupleId, ...args))
            });
    }
}

function requestCoupleAssessments(project, couple) {
    return {
        type: types.REQUEST_COUPLES_ALERTS,
        project,
        couple,
    }
}

function receiveCoupleAssessments(project, couple, assessments, icons, indexMap) {
    return {
        type: types.RECEIVE_COUPLES_ALERTS,
        project,
        couple,
        assessments,
        icons,
        indexMap
    }
}

export function setEnumsValues(options, data) {
    if (options) {
        // console.log('options setENUM', options);

        // valve.valveAlerts[0].alert_state
        const states = options.AlertState || options.alert_state;
        const types = options.AlertType;

        data.forEach(item => {
            const alertState = item.AlertState;
            const alertType = item.AlertType;
            for (let i = 0; i < states.length; i++) {
                if (states[i].value == alertState) {
                    item.AlertStateMeaning = states[i].label;
                    break;
                }
            }
            for (let i = 0; i < types.length; i++) {
                if (types[i].value == alertType) {
                    item.AlertTypeMeaning = types[i].label;
                    break;
                }
            }
            return item;
        });
        return (data);
    }
}

export function displayAssessments(display) {
    return {
        type: types.CHANGE_ASSESSMENTS_MODE,
        display,
    }
}

//--------------------------------
// Get CouplesOutputs relevance for AlertID
//--------------------------------
export function fetchCoupleSamplesForAlertIfNeeded(project, alertId) {
    return (dispatch, getState) => {
        const state = getState();
        const projectsState = state.leaksList.leaksByProject;
        const coupleId = projectsState.selectedFeature;

        //const currentOutputs = projectsState[project].coupleSamples[coupleId];
        //if (currentOutputs != null && currentOutputs.data != null) {
        //    const isInCurrentData = findAlertInData(currentOutputs.data, alertId);
        //}

        return dispatch(fetchCoupleSamplesForAlert(project, coupleId, alertId));

    }
}

function fetchCoupleSamplesForAlert(project, couple, alert) {
  const path = endPoints.END_POINT + "/couple/" + couple + "/rows/" + COUPLE_SAMPLES_COUNT_FOR_PAGE + "/alert/" + alert;

  return (dispatch, getState) => {
    dispatch(requestCoupleSamplesForAlert(project, couple, alert));
    return fetchMiddleware(path, {}, getState)
      .then(json => {
        const state = getState();
        const selectedFeatureType = state.leaksList.leaksByProject.selectedFeatureType;
        const { data } = json;
        let isExtendedInfo = true;

        let groupData;
        const { pageNumber } = data;
        if (selectedFeatureType !== 'alert') {
          groupData = data.result;
        } else {
          const selectedAlertId = alert;
          groupData = buildCoupleSamplesData(data.result, selectedAlertId);
        }

        if (groupData?.length > 0) {
          groupData.forEach((coupleOutput) => {
            const sampleDistances = [coupleOutput.DistanceIM];
            if (coupleOutput.multi) {
              coupleOutput.multi.forEach((item) => {
                sampleDistances.push(item.DistanceIM);
              })
            }

            const distancesHTML = getBoldDistancesHTML(sampleDistances, coupleOutput.DistanceAM);
            coupleOutput.distancesHTML = distancesHTML.html;
            coupleOutput.haveDistanceMatch = distancesHTML.haveMatch;

            if (coupleOutput.multi) {
              coupleOutput.multi.forEach((item) => {
                const itemDistancesHTML = getBoldDistancesHTML(sampleDistances, item.DistanceAM);
                item.distancesHTML = itemDistancesHTML.html;
                item.haveDistanceMatch = itemDistancesHTML.haveMatch;
              })
            }
          });
        }

        // console.log('fetchCoupleSamples', data, groupData, isExtendedInfo);

        dispatch(receiveCoupleSamples(project, couple, pageNumber, data, groupData, isExtendedInfo, alert));
      });
  }
}

const requestCoupleSamplesForAlert = (project, couple, alert) => {
    return {
        type: types.REQUEST_COUPLE_SAMPLES_FOR_ALERT,
        project,
        couple,
        alert,
    };
}

const receiveCoupleSamplesForAlert = (project, couple, alert, data) => {
    return {
        type: types.RECEIVE_COUPLE_SAMPLES_FOR_ALERT,
        project,
        couple,
        alert,
        data,
    };
}

//===================================
// SELECT ASSESSMENT
//===================================
export const selectAssessment = (project, alert) => {
    return {
        type: types.SELECT_COUPLE_ALERT,
        project,
        alert,
    };
};

export const setCoupleAlertsShowOnlyRealLeaks = (show) => (
    {
        type: types.ASSESSMENT_SET_SHOW_ONLY_REAL,
        show,
    }
);

export const sortAssessments = (field, dir) => {
    return (dispatch, getState) => {
        const state = getState();
        const selectedProject = state.leaksList.selectedProject;
        const selectedCouple = state.leaksList.leaksByProject.selectedFeature;
        
        if (!selectedProject || !selectedCouple) {
            return;
        }
        
        const assessmentsData = state.leaksList.leaksByProject[selectedProject].assessments[selectedCouple];
        if (!assessmentsData || !assessmentsData.assessments) {
            return;
        }
        
        // Sort locally
        const assessments = [...assessmentsData.assessments];
        const sortedAssessments = assessments.sort((a, b) => {
            const firstItem = (dir === 'asc') ? a : b;
            const secondItem = (dir === 'asc') ? b : a;
            
            if (firstItem[field] > secondItem[field]) {
                return 1;
            } else if (secondItem[field] > firstItem[field]) {
                return -1;
            } else {
                return 0;
            }
        });
        
        const indexMap = setIndexes(sortedAssessments, 'id');
        
        dispatch({
            type: types.SORT_ASSESSMENTS,
            project: selectedProject,
            couple: selectedCouple,
            assessments: sortedAssessments,
            indexMap,
            field,
            dir
        });
    };
};

function buildCoupleSamplesData(data, selectedAlertId) {
  if (!data || !selectedAlertId) return data ?? [];

  return data.map((item) => {
    if (item.LeakID === selectedAlertId) {
      return item;
    }

    if (item.multi) {
      const alertIndex = item.multi.findIndex((x) => x.LeakID === selectedAlertId);
      if (alertIndex !== -1) {
        const alertRow = { ...item.multi[alertIndex] };
        const updatedItem = { ...item };

        const fieldsToSwap = ['IsLeak', 'IsBurst', 'LeakID', 'DistanceAM', 'IntensityA', 'ProbabilityLeak'];

        for (const field of fieldsToSwap) {
          const temp = updatedItem[field];
          updatedItem[field] = alertRow[field];
          alertRow[field] = temp;
        }

        const newMulti = [...item.multi];
        newMulti[alertIndex] = alertRow;

        return {
          ...updatedItem,
          multi: newMulti
        };
      }
    }

    return item;
  });
}

const getBoldDistancesHTML = (distances, weighted) => {
  const CLOSE_DISTANCE_FACTOR = 10; // in meters
  let haveMatch = false;

  const html = distances.map((sampleDistance) => {
    const item = { value: sampleDistance, bold: false };
    // isCloseTo condition:
    if (Math.abs(sampleDistance - weighted) <= CLOSE_DISTANCE_FACTOR) {
      haveMatch = true;
      item.bold = true;
    }
    return item;
  });

  return { html, haveMatch };
}

function requestCoupleSamples(project, coupleID) {
  return {
    type: types.REQUEST_COUPLE_SAMPLES,
    project,
    coupleID
  };
}

function receiveCoupleSamples(project, coupleID, pageIndex, data, groupData, isExtendedInfo, alert) {
  return {
    type: types.RECEIVE_COUPLE_SAMPLES,
    project,
    coupleID,
    pageIndex,
    data,
    groupData,
    isExtendedInfo,
    alert,
  };
}
